import styled from 'styled-components'
import { ArrowUpDown } from '@styled-icons/remix-fill/ArrowUpDown'

export const Text = styled.p`
 margin: 0;
 font-weight: bold;
 font-family: 'Work Sans';
`

export const Button = styled.button`
  border-radius: 0.5rem;
  color: white;
  font-family: Work Sans;
  font-weight: bold;
  padding: 0.3rem 0.5rem;
  background-color: ${({ disabled, theme }) => (disabled ? '#bbbbbb' : theme.colors.blue)};
  font-size: 14px;
`

export const Container = styled.div``

export const Icon = styled(ArrowUpDown)`
  width: 1.5rem;
  margin-right: 0.5rem;
`
